import HttpRequest from './http_request'

class QuestionnaireProvider extends HttpRequest {
    constructor() {
        // api api
        super(process.env.VUE_APP_API_URL)
    }

    async getQuestionnaire(payload) {
        const { data } = await this.get('/', {
            function: 'get-student-review',
            student_id: payload.student_id,
            year: payload.year,
            semester: payload.semester
        })
        return data
    }

    async setQuestionnaire(info) {
        const { data } = await this.update('/', {
            function: 'save-student-review',
            student_id: info.student_id,
            year: info.year,
            semester: info.semester,
            Q1: info.Q1,
            Q2: info.Q2,
            Q3: info.Q3,
            Q4: info.Q4,
            Q5: info.Q5,
            Q6: info.Q6,
            COMMENT: info.COMMENT,
        })
        return data
    }
}

export default QuestionnaireProvider